import { render } from "./ReportSettingsComponent.vue?vue&type=template&id=ff8d551e&scoped=true&ts=true"
import script from "./ReportSettingsComponent.vue?vue&type=script&lang=ts"
export * from "./ReportSettingsComponent.vue?vue&type=script&lang=ts"

import "./ReportSettingsComponent.vue?vue&type=style&index=0&id=ff8d551e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8d551e"]])

export default __exports__